/**
 * Versions of the two public legal documents: the Términos y condiciones every
 * CRM user accepts, and the Aviso de privacidad handed to prospects.
 *
 * The version IS the date the text last changed, and it is fixed on purpose.
 * The aviso used to print `new Date()` as its "última actualización", so the
 * page claimed to have been rewritten every single day — a date that identifies
 * nothing. For the terms that would be worse than cosmetic: an acceptance record
 * has to name the exact text a person agreed to.
 *
 * Changing either document's text means bumping its constant here. Bumping
 * `TERMS_VERSION` makes every CRM user accept again on their next load.
 */
/** The terms currently shown. ISO date, `YYYY-MM-DD`. */
export const TERMS_VERSION = "2026-09-28";
/**
 * Every terms version the backend will record an acceptance for. Append, never
 * remove.
 *
 * The backend accepts any KNOWN version rather than only the current one because
 * the CRM (Vercel) and the API (Render) deploy independently: during the minutes
 * one is ahead of the other, "current" means two different things, and rejecting
 * the version the CRM just displayed would lock people out of the CRM. Recording
 * what the browser displayed is also the legally meaningful fact — it is the
 * text that person actually read.
 */
export const KNOWN_TERMS_VERSIONS = [TERMS_VERSION];
/** The aviso de privacidad currently published. ISO date, `YYYY-MM-DD`. */
export const PRIVACY_NOTICE_VERSION = "2026-09-28";
const MESES_ES = [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre",
];
/**
 * `"2026-09-28"` → `"28 de septiembre de 2026"`.
 *
 * Parsed by hand, never through `new Date(version)`: an ISO date-only string is
 * read as UTC midnight, which in Mexico is the previous evening, so the page
 * would print the day before the one we wrote. Returns the input unchanged when
 * it is not a well-formed date, so a typo in a constant is visible on the page
 * rather than rendered as "NaN de undefined".
 */
export function legalDateLabel(version) {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(version);
    if (!match)
        return version;
    const [, year, month, day] = match;
    const mes = MESES_ES[Number(month) - 1];
    const dia = Number(day);
    if (!mes || dia < 1 || dia > 31)
        return version;
    return `${dia} de ${mes} de ${year}`;
}
//# sourceMappingURL=legal-versions.js.map